import { useEffect, useState } from "react"
import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, Button, Typography, InputLabel } from "@mui/material"

import BackIcon from "../../../components/BackIcon"
import CustomFieldset from "../../../components/CustomFieldset"
import CustomHelperDetail from "../../../components/CustomHelperDetail"
import CustomTooltip from "../../../components/ToolTip"
import CustomDatePicker from "../../../components/CustomDatePicker"
import dayjs from "dayjs"
import CustomTextField from "../../../components/CustomTextField"
import CustomSelect from "../../../components/CustomSelect"
import CustomAutocomplete from "../../../components/CustomAutocomplete"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import { useQuery, useQueryClient, QueryClient } from "@tanstack/react-query"
import CustomBackdrop from "../../../components/CustomBackdrop"
import EjecutarIcon from "../../../assets/iconos/EjecutarAccion.ico"
import CustomMultiSelectCheckmark from "../../../components/CustomMultiSelectCheckmark"
import CustomAutoComplete from "../../SolicitudDeIngreso/components/CustomAutoComplete"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import Accordion from "@mui/material/Accordion"
import AccordionDetails from "@mui/material/AccordionDetails"
import AccordionSummary from "@mui/material/AccordionSummary"
import ExpandMore from "@mui/icons-material/ExpandMore"
import { useFetcher } from "react-router-dom"
import DatagridAllEgresos from "../components/DataGridAllEgresos"
import Swal from "sweetalert2"
const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const ContainerFiltros = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
        "Egreso Egreso Egreso Egreso Egreso Egreso Ingreso Ingreso Ingreso Ingreso Ingreso Ingreso"
        "FechaInicial FechaInicial FechaInicial FechaInicial FechaInicial FechaInicial FechaFinal FechaFinal FechaFinal FechaFinal FechaFinal FechaFinal"
        "Bodega Bodega Bodega Bodega Bodega Bodega Articulo Articulo Articulo Articulo Articulo Articulo"
        "Detalle Detalle Detalle Detalle Detalle Detalle Detalle Detalle Detalle Detalle Detalle Detalle"
        `,

  gap: "8px",
  alignItems: "center",
}))

const EgresoBox = styled(Box)({
  gridArea: "Egreso",
})

const IngresoBox = styled(Box)({
  gridArea: "Ingreso",
})
const FechaInicialBox = styled(Box)({
  gridArea: "FechaInicial",
})

const DetalleBox = styled(Box)({
  gridArea: "Detalle",
})

const FechaFinalBox = styled(Box)({
  gridArea: "FechaFinal",
})

const ArticuloBox = styled(Box)({
  gridArea: "Articulo",
})
const BodegaBox = styled(Box)({
  gridArea: "Bodega",
})

const BuscarPickingEgreso = () => {
  const queryClient = useQueryClient()
  const [expanded, setExpanded] = useState(true)
  const [searchAttempted, setSearchAttempted] = useState(false)
  const [isFirstTime, setFirstTime] = useState(true)
  const [filtros, setFiltros] = useState({
    ingreso: "",
    egreso: "",
    detalle: "",
    articulo: {},
    fechaInicial: dayjs(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
    fechaFinal: dayjs(new Date()),
  })
  const [bodega, setBodega] = useState("")
  const [bodegaDescripcion, setBodegaDescripcion] = useState("")
  const [autoCompleteValueBodega, setAutoCompleteValueBodega] = useState("")
  const [bodegas, setBodegas] = useState([])
  const handleExpandAccordion = () => {
    setExpanded((prevExpanded) => !prevExpanded)
  }
  const handleSetFiltros = (key, value) => {
    if (filtros[key] !== value) {
      setFiltros((prev) => ({ ...prev, [key]: value }))
    }
  }
  const showErrorAlert = (errorMessage) => {
    Swal.fire({
      title: "Error",
      text: errorMessage,
      icon: "error",
      confirmButtonText: "OK",
    })
  }
  const {
    data: dataBodegas = [],
    isError: dataBodegasError,
    isFetching: isFetchingBodegas,
    isLoading: isLoadingBodegas,
    refetch: refetchGetAllBodegas,
  } = useGetAllBodegas()
  useEffect(() => {
    // Solo actualiza bodegas si dataBodegas tiene valores
    if (dataBodegas.length > 0) {
      setBodegas(dataBodegas)
    }
  }, [dataBodegas])
  const handleBodegaChange = (selectedValue) => {
    const [codigo, descripcion] = selectedValue.split("-")
    setBodega(codigo)
    setBodegaDescripcion(descripcion)
    setAutoCompleteValueBodega(selectedValue)
  }
  useEffect(() => {
    console.log("useEffectBodegaNombre")
    setBodega(bodega)
    setBodegaDescripcion(bodegaDescripcion)
    console.log("informacion de bodega selected", bodega, bodegaDescripcion)
  }, [bodega])
  function useGetAllBodegas() {
    return useQuery({
      queryKey: ["EgresoPickingBodega"],
      queryFn: async () => {
        const options = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log("json enviado a la api", options.body)
        const response = await fetchwrapper("/Bodegas/getBodegas", options)
        const result = await response.json()
        console.log("datos de la api", result)
        return result.bodegas
      },
      enabled: true,
      onError: (error) => {
        console.log("Error fetching data", error)
      },
    })
  }
  const {
    data: fetchedFilteredEgresos = [],
    isError: isLoadingFilteredEgresosError,
    isFetching: isFetchingFilteredEgresos,
    isLoading: isLoadingFilteredEgresos,
    refetch: refetchFilteredEgresos,
  } = useGetFilteredEgresos()

  function useGetFilteredEgresos() {
    return useQuery({
      queryKey: ["fetchedFilteredEgresosPickingsBuscar"],
      queryFn: async () => {
        const options = {
          method: "POST",
          body: JSON.stringify({
            tranumero: filtros.egreso,
            pctacodigo: filtros.ingreso,
            fechaInicial: filtros.fechaInicial,
            fechaFinal: filtros.fechaFinal,
            bodcodigo: bodega,
            artcodigo: filtros.articulo.artcodigo,
            tradescripcion: filtros.detalle,
          }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log("json enviado para filtrar", options.body)
        try {
          let response = await fetchwrapper(`/EgresoPicking/getEgresosFiltro`, options)
          if (!response.ok) {
            const errorData = await response.json()
            console.log("error message", errorData)
            // Throw the error so it can be caught in the catch block
            throw new Error(errorData.error || "An unknown error occurred")
          }
          response = await response.json()

          return response.data
        } catch (error) {
          Swal.fire({
            title: "Error",
            text: error.message || "Error fetching filtered Egresos",
            icon: "error",
            confirmButtonText: "OK",
          })
          throw error
        }
      },
      refetchOnWindowFocus: false,
      staleTime: 0,
      enabled: !searchAttempted && !isFirstTime,
      cacheTime: 0,
    })
  }
  useEffect(() => {
    return () => {
      // Limpia la caché cuando el componente se desmonta
      queryClient.removeQueries(["fetchedFilteredEgresosPickingsBuscar"])
    }
  }, [queryClient])

  const handleSearching = () => {
    setSearchAttempted(true)
    setExpanded(false)
    refetchFilteredEgresos()
    limpiarFiltros()
  }
  const limpiarFiltros = () => {
    setBodega("")
    setBodegaDescripcion("")
    setAutoCompleteValueBodega("")
    filtros.ingreso = ""
    filtros.egreso = ""
    filtros.detalle = ""
    filtros.articulo = {}
    filtros.fechaFinal = null
    filtros.fechaInicial = null
  }
  useEffect(() => {
    // Verifica si la búsqueda fue intentada y los datos ya no están cargándose
    if (searchAttempted && !isLoadingFilteredEgresos && !isFetchingFilteredEgresos && !isFirstTime) {
      console.log("filtros limpioss")
      limpiarFiltros()
    }
  }, [isFetchingFilteredEgresos, isLoadingFilteredEgresos, searchAttempted])
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "16px", padding: "5px" }}>
            <CustomTooltip title={"Ejecutar"}>
              <Button onClick={handleSearching}>
                <img src={EjecutarIcon} alt="Ejecutar" style={{ width: "40px" }} />
              </Button>
            </CustomTooltip>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Egreso por Picking</b>
        </div>

        <CustomBackdrop isLoading={isLoadingFilteredEgresos || isFetchingFilteredEgresos} />

        <Box className={StyledRoot}>
          <Accordion expanded={expanded} onChange={handleExpandAccordion} slotProps={{ heading: { component: "h2" } }}>
            <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1a-content" id="panel1a-header">
              <Typography variant="h6" style={{ width: "100%", textAlign: "center" }}>
                Criterios de búsqueda
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <ContainerFiltros>
                <EgresoBox>
                  <CustomTextField
                    label="Egreso"
                    value={filtros.egreso}
                    setValue={(v) => handleSetFiltros("egreso", v)}
                  />
                </EgresoBox>
                <IngresoBox>
                  <CustomTextField
                    label="Ingreso"
                    value={filtros.ingreso}
                    setValue={(v) => handleSetFiltros("ingreso", v)}
                  />
                </IngresoBox>
                <FechaInicialBox>
                  <CustomDatePicker
                    label="Fecha Inicial"
                    value={filtros.fechaInicial}
                    setValue={(v) => handleSetFiltros("fechaInicial", v)}
                    isOptional={true}
                  />
                </FechaInicialBox>
                <FechaFinalBox>
                  <CustomDatePicker
                    label="Fecha Final"
                    value={filtros.fechaFinal}
                    setValue={(v) => handleSetFiltros("fechaFinal", v)}
                    isOptional={true}
                  />
                </FechaFinalBox>
                <BodegaBox>
                  <InputLabel>Bodega</InputLabel>
                  <CustomAutoComplete
                    items={dataBodegas}
                    onSelect={handleBodegaChange}
                    placeholder={"Buscar Bodega"}
                    value={autoCompleteValueBodega}
                  />
                </BodegaBox>
                <ArticuloBox>
                  <CustomHelperDetail
                    label="Artículo"
                    valueSearched={filtros.articulo?.artcodigo}
                    endpoint="/CierrePicking/getArticulosHelper"
                    valueInputMain="artcodigo"
                    valueInputSecondary="artdescri"
                    idSearchField="artcodigo"
                    errorMsgIdSearch="Error fetching data:"
                    errorMsgFilterSearch="Error en cargar datos"
                    queryKeyModal="articuloCierrepicking"
                    perPage={10}
                    placeholder=""
                    columnsTable={[
                      {
                        accessorKey: "artcodigo",
                        header: "Código",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "artdescri",
                        header: "Descripción",
                        size: 150,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "artcantactual",
                        header: "Cantidad Actual",
                        size: 120,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "artprecventa1",
                        header: "Precio Venta 1",
                        size: 120,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "mardescri",
                        header: "Marca",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "artcodigo2",
                        header: "Código 2",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "lindescri",
                        header: "Línea",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "predescri",
                        header: "Precio Descripción",
                        size: 150,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "meddescri",
                        header: "Medida",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "artprecventa2",
                        header: "Precio Venta 2",
                        size: 120,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "artprecventa3",
                        header: "Precio Venta 3",
                        size: 120,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "artprecventa4",
                        header: "Precio Venta 4",
                        size: 120,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "artprecventa5",
                        header: "Precio Venta 5",
                        size: 120,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "artprecventa6",
                        header: "Precio Venta 6",
                        size: 120,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "artstatus",
                        header: "Estado",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                    ]}
                    onHandleSelectedData={(v) => handleSetFiltros("articulo", v)}
                    sxInputMain={{
                      minWidth: "170px",
                      maxWidth: "170px",
                      marginRight: "10px",
                    }}
                    sxInputSecondary={{
                      width: "100%",
                    }}
                  />
                </ArticuloBox>
                <DetalleBox>
                  <CustomTextField
                    label="Detalle"
                    value={filtros.detalle}
                    setValue={(v) => handleSetFiltros("detalle", v)}
                    fullwidth
                  />
                </DetalleBox>
              </ContainerFiltros>
            </AccordionDetails>
          </Accordion>
          <DatagridAllEgresos
            fetchedInfo={fetchedFilteredEgresos}
            isLoadingInfoError={isLoadingFilteredEgresosError}
            isLoadingInfo={isLoadingFilteredEgresos}
            isFetchingInfo={isFetchingFilteredEgresos}
            columnsTable={[
              {
                accessorKey: "ciacodigo",
                header: "Cía",
                size: 100,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "tranumero",
                header: "Egreso",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "trafecha",
                header: "Fecha",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{normalFormatDate(value)}</span>
                },
              },
              {
                accessorKey: "trahora",
                header: "Hora ",
                size: 100,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "tradescripcion",
                header: "Descripcion",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "invdescri",
                header: "Inventario",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "boddescri",
                header: "Bodega",
                size: 200,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "clinombre",
                header: "Cliente",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "pctacodigo",
                header: "Ingreso",
                size: 100,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "tradescri",
                header: "Transaccion",
                size: 100,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
            ]}
          />
          <br />
          <br />
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default BuscarPickingEgreso
